/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_input__clear = /** @type {(inputs: {}) => string} */ () => {
	return `Eingabe löschen`
};

const en_input__clear = /** @type {(inputs: {}) => string} */ () => {
	return `Clear input`
};

const es_input__clear = /** @type {(inputs: {}) => string} */ () => {
	return `Borrar entrada`
};

const fr_input__clear = /** @type {(inputs: {}) => string} */ () => {
	return `Effacer la saisie`
};

const it_input__clear = /** @type {(inputs: {}) => string} */ () => {
	return `Cancella immissione`
};

const nl_input__clear = /** @type {(inputs: {}) => string} */ () => {
	return `Invoer wissen`
};

const pt_input__clear = /** @type {(inputs: {}) => string} */ () => {
	return `Eliminar preenchimento`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const input__clear = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.input__clear(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("input__clear", locale)
	if (locale === "de") return de_input__clear(inputs)
	if (locale === "en") return en_input__clear(inputs)
	if (locale === "es") return es_input__clear(inputs)
	if (locale === "fr") return fr_input__clear(inputs)
	if (locale === "it") return it_input__clear(inputs)
	if (locale === "nl") return nl_input__clear(inputs)
	return pt_input__clear(inputs)
};